<template>
	<div id="dashboard-secondary-header">
		<div class="col md-4">
			<template v-if="user">
				<div class="dash__profile"></div>
				<div class="dash__welcome">
					<div class="dash__welcome-text">Welcome back,</div>
					<div class="dash__welcome-user">{{user.firstName}}</div>
				</div>
			</template>
		</div>
		<div class="col md-8 dash__stats">
			<template v-if="surveyStats">
				<div class="col xs-6 sm-6 md-6 lg-3 dash__stat" v-for="(survey, i) in surveyStats">
					<p class="dash__val">{{survey.count}}</p>
					<p class="dash__desc">{{survey.fieldName}}</p>
				</div>
			</template>
		</div>
		<div class="clearfix"></div>
	</div>
</template>

<script>
	export default {
		props: ['user', 'surveyStats']
	}
</script>



// WEBPACK FOOTER //
// src/components/common/Dashboard/DBSecondaryHeader.vue